import * as React from 'react'

import { classList } from 'react-classlist-helper'

import { Loader } from '~/client/src/shared/components/Loader'

import { useMobileResourceState } from '../context'
import { LayoutProps } from './types'

export const MobileResourceContent: React.FC<LayoutProps> = ({
  children,
  className,
}) => {
  const { loading } = useMobileResourceState()

  if (loading) {
    return <Loader />
  }

  return (
    <div
      className={classList({
        'tw:h-full tw:flex tw:flex-col': true,
        [className || '']: !!className,
      })}
    >
      {children}
    </div>
  )
}
